function AnalysisMatchesCardView() {
    "use strict";
    this.Distance = 0;
    this.DistanceDisplay = '';
    this.DistanceDisplayView = 'block';
    this.EndDateUTC = new Date('12/31/9999');
    this.EnrolleeId = -1;
    this.EnrolleeName = '- unauthorized -';
    this.PrimaryId = '- unauthorized -';
    this.RiskLevelId = -1;
    this.StartDateUTC = new Date();
    this.Score = 0;
    this.ScoreView = 'block';
    this.TrackpointCount = 0;
    this.OrganizationId = -1;
    this.Data = null;
    this.StartDateDisplay = '- unknown -';
    this.EndDateDisplay = '- unknown -';
    this.TrackDateDisplay = '- unknown -';
    this.AgentId = -1;
    this.Agent = '- unauthorized -';
    this.AgentPrimaryEmail = '- unauthorized -';
    this.DistanceMeasurement = 'feet';
    this.Id = -1;
    this.TrackingDeviceSerialNumber = '';
    this.TrackingDeviceId = -1;
    this.SpatialMatchSearch = 0;
    this.IsDeleted = false;
    this.IsDeletableClass = '';
    this.TimeZoneId = -1;

    ////support for extra types
    this.Detail = '';
    this.Detail2 = '';
    this.Detail3 = '';
    this.AgentDisplayView = 'show';
    this.TrackCountDisplayView = 'show';
    this.DisplayName = '';
    this.IconClass = '';
    this.Type = 1;
    this.TrackItem = [];
    this.DisplayNavigateEnrollee = 'show';
    //{types 1 = enrollee 2 = address}
    //this.DisplayName = '';
    //this.IconClass = '';
}
if (typeof exports !== 'undefined') {
    module.exports = AnalysisMatchesCardView;
}